var base6 = window.base6;
var base5 = window.base5;
var base4 = window.base4;
var base3 = window.base3;
var base2 = window.base2;
var base1 = window.base1;
var base = window.base;
var base, base1, base2, base3, base4, base5, base6;
window.Components || (window.Components = {});
(base = window.Components).Toasts || (base.Toasts = {});
(base1 = window.Components).Modals || (base1.Modals = {});
(base2 = window.Components).Basic || (base2.Basic = {});
(base3 = window.Components).Compound || (base3.Compound = {});
(base4 = window.Components).Buttons || (base4.Buttons = {});
(base5 = window.Components).Application || (base5.Application = {});
(base6 = window.Components.Application).User || (base6.User = {});
window.define = null;
window.base = base;
window.base1 = base1;
window.base2 = base2;
window.base3 = base3;
window.base4 = base4;
window.base5 = base5;
window.base6 = base6;